import React from 'react'
import { Card, Col } from 'antd'
import PropTypes from 'prop-types'
import './ImageDataCard.scss'

export default function ImageDataCard({ children, icon, onClick, ...rest }) {
  const tryToRenderIcon = () => (!icon ? null : icon())

  return (
    <Card
      {...rest}
      className="card image-data-card"
      onClick={onClick}
      style={{ margin: 0, padding: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {tryToRenderIcon()}
        <Col className="gutter-row">{children}</Col>
      </div>
    </Card>
  )
}

ImageDataCard.propTypes = {
  icon: PropTypes.func,
  children: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired
}
